import { render, staticRenderFns } from "./CheckboxComponent.vue?vue&type=template&id=562efa91&scoped=true&"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js&"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562efa91",
  null
  
)

export default component.exports